import React, { Fragment, useState, useCallback, useEffect } from 'react';
import {
    Row, 
    Col,
    Card,
    ListGroup, 
    ListGroupItem,
    Container
} from 'reactstrap';
import Select from 'react-select';

import avatar from '../../../../../assets/utils/images/avatars/avatar.png';

import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';

export default function GiftsList(props){
    const {
        givers
    } = props;

    const [plans, setPlans] = useState([]);
    const { toggleLoading, currentGroup } = useAuth();
    const [enableGiverFilters] = useState(true);

    const options = () => {
        let options = [];
        // eslint-disable-next-line
        if (givers) {
            givers.map((giver) => {
                options.push(
                    {
                        value: giver.id,
                        label: giver.name
                    }
                );
                return giver;
            });
        }

        options.push({
            value: '',
            label: 'All'
        })
        
        return options;
    }

    const getPlans = useCallback(() => {
        setPlans([]);
        toggleLoading(true);
        api.get(`/ro.team.listAllPlanGift/${currentGroup.id}`)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setPlans(response.data);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [setPlans, currentGroup, toggleLoading]);

    const changeGiver = useCallback((event) => {
        const currentGiverId = event.value;
        setPlans([]);
        
        if (currentGiverId) {
            toggleLoading(true);
            api.post(`/ro.team.listGiverPlanGift/${currentGroup.id}`, {
                giverId: currentGiverId
            })
                .then((response) => {
                    if (response.data && response.data.length > 0) {
                        setPlans(response.data);
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        } else {
            getPlans();
        }
    }, [toggleLoading, currentGroup, setPlans, getPlans]);

    useEffect(() => {
        getPlans();
    }, [getPlans]);

    return (
        <Fragment>
            <Container fluid>
                {enableGiverFilters && (
                    <Row className="mb-4">
                        <Col lg="12">
                            <Select
                                options={options()}
                                placeholder="Select a Volunteer"
                                onChange={changeGiver}
                                defaultValue={{ value: '', label: 'All' }}
                            />
                        </Col>
                    </Row>
                )}                
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup flush>
                                {plans && plans.map((plan) => (
                                    <ListGroupItem key={plan.id}>
                                        <div className="widget-content p-0">
                                            <div className="widget-content-wrapper">
                                                <div className="widget-content-left mr-3">
                                                    <img width={42} className="rounded-circle" src={avatar}
                                                            alt=""/>
                                                </div>
                                                <div className="widget-content-left">
                                                    <div className="widget-heading">
                                                        {plan.receiver.name}
                                                    </div>
                                                    {plan.receiver.phone && (
                                                        <div className="widget-subheading">
                                                            Phone: <a href={`tel:${plan.receiver.phone}`} target="_blank" rel="noopener noreferrer">{plan.receiver.phone}</a>
                                                        </div>
                                                    )}
                                                    <div className="widget-subheading">
                                                        Volunteer: {plan.giver.name}
                                                    </div>                                                   
                                                    <div className="widget-subheading">
                                                        {plan.plan.times} per {plan.plan.times_per} / At {plan.plan.period}
                                                    </div>
                                                    <div className="widget-subheading">
                                                        {plan.notes}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};
